import { ServiceTypes } from "../../../../src/components/ServiceTypes";
import * as React from 'react';
export default {
  ServiceTypes,
  React
};